import { render, staticRenderFns } from "./canReceiveList.vue?vue&type=template&id=e980d5b4&scoped=true&"
import script from "./canReceiveList.vue?vue&type=script&lang=js&"
export * from "./canReceiveList.vue?vue&type=script&lang=js&"
import style0 from "./canReceiveList.vue?vue&type=style&index=0&id=e980d5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e980d5b4",
  null
  
)

export default component.exports